<template>
  <div id="app">
      <router-view name="blank"></router-view>
      <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: 'app',
  }
</script>

<style lang="scss">
  #app {
    background-color: #222d32;
  }
  .suo{
  text-align: center;
  border: 1px solid #e9e9eb;
  border-radius: 30px;
  font-size: 12px;
  display: inline-block;
  padding: 0px 10px;
}
.tooltipWidth{
  max-width: 250px;
}
</style>
